/*jshint esversion: 9 */
import log from "loglevel";
import remote from "loglevel-plugin-remote";
// import moment from "moment";

let loggingInitialized = false;
let remoteLogging = true;
// let productionMode = false;
// let agencyLog = null;
let appOptions = null;
let doLogging = false;
let serverAppPath = "";

export const checkValidity = (value, rules) => {
  const result = {
    isValid: true,
    invalidMsg: "",
  };

  // console.log("utility.checkValidity value:" + value + " rules:", rules);
  if (rules) {
    if (rules.required) {
      if (!value || value === null) {
        result.isValid = false;
      } else {
        //   result.isValid = value.trim() !== "";
        result.isValid = value !== "";
      }
      if (!result.isValid) {
        result.invalidMsg = "Required.";
      }
    }

    if (result.isValid && rules.minLength) {
      result.isValid = value.length >= rules.minLength;
      if (!result.isValid) {
        result.invalidMsg =
          "Must be " + rules.minLength + " characters or more.";
      }
    }

    if (result.isValid && rules.maxLength) {
      result.isValid = value.length <= rules.maxLength;
      if (!result.isValid) {
        result.invalidMsg =
          "Must be " + rules.maxLength + " characters or less.";
      }
    }
  }
  // console.log("checkValidity result:", result);

  return result;
};

export const initializeLogging = (
  newAgencyCode,
  newRemoteLogging,
  newProductionMode
) => {
  // agencyCode = newAgencyCode;
  remoteLogging = newRemoteLogging;
  // productionMode = newProductionMode;

  // if (productionMode) {
  //   log.setLevel("warn"); // set to "warn" to ignore trace, debug and info messages
  // } else {
  log.enableAll();
  // }

  // console.log("initializeLogging agencyCode:" + agencyCode);
  // agencyLog = log.getLogger(agencyCode);
  // console.log("initializeLogging agencyLog:", agencyLog);
  console.log("initializeLogging log:", log);

  if (remoteLogging) {
    const defaults = {
      url: "http://localhost:8081/transaction/citizenweb/logger",
      method: "POST",
      headers: {},
      token: "",
      onUnauthorized: (failedToken) => {},
      timeout: 0,
      interval: 1000,
      level: "trace",
      backoff: {
        multiplier: 2,
        jitter: 0.1,
        limit: 30000,
      },
      capacity: 500,
      stacktrace: {
        levels: ["trace", "warn", "error"],
        depth: 3,
        excess: 0,
      },
      timestamp: () => new Date().toISOString(),
      format: remote.plain,
      //   format: remote.json,
      //   format: (log) => {
      //     return `[${log.timestamp}] ${log.level.label.toUpperCase()}${
      //         log.logger.name ? ` (${log.logger.name})` : ''
      //       }: ${log.message}${log.stacktrace ? `\n${log.stacktrace}` : ''}`;
      //   }
    };
    remote.apply(log, defaults);
  }

  loggingInitialized = true;
};

export const Log = (str1, str2, str3, str4) => {
  if (loggingInitialized) {
    if (hasValue(str4))
      log.info(
        stringifyIfObject(str1),
        stringifyIfObject(str2),
        stringifyIfObject(str3),
        stringifyIfObject(str4)
      );
    else if (hasValue(str3))
      log.info(
        stringifyIfObject(str1),
        stringifyIfObject(str2),
        stringifyIfObject(str3)
      );
    else if (hasValue(str2))
      log.info(stringifyIfObject(str1), stringifyIfObject(str2));
    else log.info(stringifyIfObject(str1));
  }
};

export const LogDebug = (str1, str2, str3, str4) => {
  if (loggingInitialized) {
    if (hasValue(str4))
      log.debug(
        stringifyIfObject(str1),
        stringifyIfObject(str2),
        stringifyIfObject(str3),
        stringifyIfObject(str4)
      );
    else if (hasValue(str3))
      log.debug(
        stringifyIfObject(str1),
        stringifyIfObject(str2),
        stringifyIfObject(str3)
      );
    else if (hasValue(str2))
      log.debug(stringifyIfObject(str1), stringifyIfObject(str2));
    else log.debug(stringifyIfObject(str1));
  }
};

export const LogWarn = (str1, str2, str3, str4) => {
  //   const timestamp = moment().format("YYYY-MM-DD hh:mm:ss");
  //   if (hasValue(str4)) log.warn(timestamp + " " + str1, str2, str3, str4);
  //   else if (hasValue(str3)) log.warn(timestamp + " " + str1, str2, str3);
  //   else if (hasValue(str2)) log.warn(timestamp + " " + str1, str2);
  //   else log.warn(timestamp + " " + str1);
  if (loggingInitialized) {
    if (hasValue(str4))
      log.warn(
        stringifyIfObject(str1),
        stringifyIfObject(str2),
        stringifyIfObject(str3),
        stringifyIfObject(str4)
      );
    else if (hasValue(str3))
      log.warn(
        stringifyIfObject(str1),
        stringifyIfObject(str2),
        stringifyIfObject(str3)
      );
    else if (hasValue(str2))
      log.warn(stringifyIfObject(str1), stringifyIfObject(str2));
    else log.warn(stringifyIfObject(str1));
  }
};

export const deepCopy = (obj) => {
  // console.log('[deepCopy] obj:', obj);
  if (!obj || obj === null) return null;
  else {
    return JSON.parse(JSON.stringify(obj));
  }
};

export const doLog = () => {
  // console.log("[utility] doLog doLogging:", doLogging);
  return doLogging;
};

export const formatNN = (num) => {
  return pad(num, 2, "0");
};

export const getAppOptions = () => {
  return appOptions;
};

export const getFeetInches = (value) => {
  //5'5" needs to be 5'05"
  let height = notNull(value);
  console.log(
    "getFeetInches new height:" + height + " length:" + height.length
  );
  let feet = 0;
  let inches = 0;
  const footPos = height.indexOf("'");
  const inchPos = height.indexOf('"');
  console.log("getFeetInches footPos:" + footPos + " inchPos:" + inchPos);
  if (footPos === -1 && inchPos === -1 && height.length > 1) {
    feet = height.substring(0, 1);
    inches = height.substring(1);
    if (inches.length > 2) inches = inches.substring(0, 2);
    height = feet + "'" + formatNN(inches) + '"';
    console.log("getFeetInches feet:" + feet + " inches:" + inches);
  } else {
    feet = height.substring(0, footPos);
    if (feet.length > 1) feet = feet.substring(0, 1);
    inches = height.substring(footPos + 1, inchPos);
    if (inches.length > 2) inches = inches.substring(0, 2);
    console.log("getFeetInches feet:" + feet + " inches:" + inches);
    height = feet + "'" + formatNN(inches) + '"';
  }
  console.log("getFeetInches resulting height:" + height);

  return height;
};

export const getMoneyString = (value) => {
  // console.log('getMoneyString:', getNumber( notNull(value) ).toFixed(2));
  return getNumber(notNull(value)).toFixed(2);
};

export const getMMDDYYYY = (value) => {
  let newDate = notNull(value);
  const pos = newDate.indexOf(" 00:");
  if (pos > 0) {
    newDate = newDate.substring(0, pos);
  }
  if (newDate.length >= 10) {
    newDate =
      newDate.substring(5, 7) +
      "/" +
      newDate.substring(8, 10) +
      "/" +
      newDate.substring(0, 4);
  }
  return newDate;
};

export const getMMDDYYYYTime = (value) => {
  const newDateTime = notNull(value);
  let newDate = notNull(value);
  let newTime = "";
  // console.log("getMMDDYYYYTime newDateTime:", newDateTime);
  // console.log("getMMDDYYYYTime newDate:", newDate);
  // console.log("getMMDDYYYYTime newTime:", newTime);
  let pos = newDateTime.indexOf(":");
  // console.log("getMMDDYYYYTime pos:", pos);
  if (pos > 2) {
    pos = pos - 3;
    newDate = newDateTime.substring(0, pos);
    newTime = newDateTime.substring(pos + 1);
  }
  // console.log("getMMDDYYYYTime split newDate:", newDate);
  // console.log("getMMDDYYYYTime split newTime:", newTime);
  if (newDate.length === 10) {
    newDate =
      newDate.substring(5, 7) +
      "/" +
      newDate.substring(8, 10) +
      "/" +
      newDate.substring(0, 4);
  }
  if (newTime.length >= 7) {
    let hour = newTime.substring(0, 2);
    let minute = newTime.substring(3, 5);
    let ampm = " AM";
    // console.log("getMMDDYYYYTime split hour:", hour);
    if (hour >= 12) {
      ampm = " PM";
      if (hour > 12) hour = hour - 12;
    }
    newTime = hour + ":" + minute + ampm;
  }
  // console.log("getMMDDYYYYTime newDate:", newDate);
  // console.log("getMMDDYYYYTime newTime:", newTime);
  return newDate + " " + newTime;
};

export const getYYYYMMDD = (value) => {
  let newDate = notNull(value);
  const pos = newDate.indexOf(" 00:");
  if (pos > 0) {
    newDate = newDate.substring(0, pos);
  }
  if (newDate.length >= 10) {
    newDate =
      newDate.substring(6, 10) +
      "-" +
      newDate.substring(0, 2) +
      "-" +
      newDate.substring(3, 5);
  }
  return newDate;
};

export const getNumber = (value) => {
  if (notNull(value) === "") {
    value = "0";
  }
  // console.log('getNumber value:', "" + value);
  // console.log('getNumber:', "" + Number.parseFloat( notNull(value) ));
  return Number.parseFloat(notNull(value));
};

export const getNumberString = (value) => {
  // console.log('getNumberString:', getNumber( notNull(value) ).toFixed(0));
  return getNumber(notNull(value)).toFixed(0);
};

export const getServerAppPath = () => {
  return serverAppPath;
};

export const getSubElement = (baseElement, elementName) => {
  // LogDebug("[utility] getSubElement baseElement:", baseElement);
  // LogDebug("[utility] getSubElement elementName:", elementName);
  let subElement = null;
  let found = false;
  const elementCount = baseElement.childElementCount;
  // LogDebug("[utility] getSubElement elementCount:", elementCount);
  for (let i = 0; i < elementCount && !found; i++) {
    let element = baseElement.children[i];
    // LogDebug("[utility] getSubElement element[" + i + "]:", element);
    let localName = element.localName;
    // LogDebug("[utility] getSubElement localName:", localName);
    if (elementName === localName) {
      subElement = element;
      found = true;
      // LogDebug("[utility] getSubElement found match");
    } else {
      subElement = getSubElement(element, elementName);
    }
  }

  return subElement;
};

export const getToday = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  today = mm + "/" + dd + "/" + yyyy;
  return today;
};

export const getTodayYMDTime = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();
  var hour = String(today.getHours()).padStart(2, "0");
  var minute = String(today.getMinutes()).padStart(2, "0");
  var seconds = String(today.getSeconds()).padStart(2, "0");

  // today = mm + '/' + dd + '/' + yyyy;
  today =
    yyyy + "-" + mm + "-" + dd + " " + hour + ":" + minute + ":" + seconds;
  return today;
};

export const hasValue = (variable) => {
  return variable && variable !== null;
};

const lookupIndexFromList = (array, value) => {
  for (let i = 0; i < array.length; i += 1) {
    if ("" + array[i].value === value) return i;
  }
  return -1;
};

export const lookupLabelFromList = (array, value) => {
  // console.log('lookupLabelFromList array:', array);
  // console.log('lookupLabelFromList value:', value);
  let result = "";
  if (value && value !== null && array && array !== null) {
    const index = lookupIndexFromList(array, value);
    // console.log('lookupLabelFromList index:', index);
    if (index !== -1) {
      result = array[index].label;
    }
  }
  // console.log('lookupLabelFromList result:', result);
  return result;
};

export const notNull = (value) => {
  // console.log('[notNull] value:',value);
  let newValue = "" + value;
  if (!value || value === null) {
    newValue = "";
  }

  // console.log('[notNull] newValue:',newValue);
  return newValue;
};

export const pad = (num, length, padWith) => {
  if (num.length > length) {
    return num;
  } else {
    const neededPads = length - num.length;
    let tmpBuf = "";
    for (let i = 0; i < neededPads; i++) {
      tmpBuf += padWith;
    }
    tmpBuf += num;
    return tmpBuf;
  }
};

export const setAppOptions = (params) => {
  appOptions = params;
  if (doLog()) console.log("[utility] setAppOptions appOptions:", appOptions);
};

export const setLogging = (on) => {
  doLogging = on;
  console.log("[utility] setLogging doLogging:", doLogging);
};

export const setServerAppPath = (path) => {
  serverAppPath = path;
};

export const stringifyIfObject = (value) => {
  //   console.log("value:", value);
  //   console.log("value type:" + typeof value);
  let result = "";
  if (typeof value === "string") {
    result = value;
  } else if (hasValue(value.$$typeof)) {
    result = "[object]";
  } else {
    if (remoteLogging)
      // result = JSON.stringify(value, null, 2);
      result = JSON.stringify(value, null, 0);
    else result = value;
  }
  //   console.log("result:", result);

  return result;
};

export const trimString = (value) => {
  //return value.replace(/^\s+|\s+$/gm,'');
  let newValue = value;
  let textPos = value.search(/\S|$/);
  // console.log("trimString value:", value);
  // console.log("trimString textPos:", textPos);
  newValue = value.substring(textPos);
  // console.log("trimString newValue:" + newValue);
  // console.log("trimString text char:", value.slice(textPos, textPos + 1) );
  return newValue;
};

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const zeroIfNull = (value) => {
  // console.log('[zeroIfNull] value:',value);
  let newValue = 0;
  if (value && value != null) {
    newValue = value;
  }

  // console.log('[zeroIfNull] newValue:',newValue);
  return newValue;
};
